'use client';
import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
import * as __WEBPACK_EXTERNAL_MODULE__nestle_npus_nbm_purina_auth_11a881f8__ from "@nestle-npus-nbm/purina-auth";
import * as __WEBPACK_EXTERNAL_MODULE_swr__ from "swr";
import * as __WEBPACK_EXTERNAL_MODULE__common_awsSettings_mjs_d7f3d5de__ from "../../../common/awsSettings.mjs";
const useGetCognitoUser = (config)=>{
    const Auth = __WEBPACK_EXTERNAL_MODULE_react__["default"].useMemo(()=>(0, __WEBPACK_EXTERNAL_MODULE__nestle_npus_nbm_purina_auth_11a881f8__.profileAuth)({
            cognito: (0, __WEBPACK_EXTERNAL_MODULE__common_awsSettings_mjs_d7f3d5de__.getAwsSettings)(config.cognito).Auth,
            pup: {
                url: config.pup.url
            }
        }), [
        config.cognito
    ]);
    const fetcher = ()=>Auth.getSession();
    const { data, error, isLoading, mutate } = (0, __WEBPACK_EXTERNAL_MODULE_swr__["default"])('GetCognitoUser', fetcher, {
        revalidateOnFocus: false,
        dedupingInterval: 5000
    });
    return {
        ansiraId: data?.idTokenAttributes?.[__WEBPACK_EXTERNAL_MODULE__nestle_npus_nbm_purina_auth_11a881f8__.legacyIdTokenPayloadKeys.ansiraId],
        ansiraUuid: data?.idTokenAttributes?.[__WEBPACK_EXTERNAL_MODULE__nestle_npus_nbm_purina_auth_11a881f8__.legacyIdTokenPayloadKeys.ansiraUuid],
        attributes: data?.idTokenAttributes,
        accessToken: data?.accessToken,
        idToken: data?.idToken,
        error,
        isLoading,
        mutate
    };
};
export { useGetCognitoUser };
